import { type CountryCode } from '@resurs-internal/mui/assets/countries';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { fetchProducts } from '@/services';
import { type DepositProduct } from '@/types/consumer-deposit-application-service';

export const useProducts = (country: CountryCode) => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<DepositProduct[]>([]);

  useEffect(() => {
    fetchProducts(country)
      .then((result) => {
        setProducts(result);
      })
      .catch(() => navigate('/error'))
      .finally(() => {
        setLoading(false);
      });
  }, [navigate, country]);

  const productFromCode = (productCode: string) => {
    if (products)
      return products[
        products.findIndex(
          (singleProduct) => productCode === singleProduct.code,
        )
      ];
  };

  return {
    isLoading,
    productFromCode,
    products,
  };
};
